import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { AlertService, UserService } from '../../../_services';
import { CognitoService } from '../../../_services/Cognito.service';
@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {
  changePasswordData;
  changePasswordForm: FormGroup;
  passwordSpecialMatch = false;
  matchPassword = false;
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private userService: UserService,
    private alertService: AlertService,
    private cognitoService: CognitoService,
  ) {
    this.changePasswordData = {
      current_password: '',
      new_password: '',
      new_password_confirm: ''
    };
   }

  ngOnInit() {

    this.changePasswordForm = this.fb.group({
      'current_password': ['', [
        Validators.required,
        Validators.minLength(8),
        Validators.maxLength(20),
      ]],
      'new_password': ['', [
        Validators.required,
        Validators.minLength(8),
        Validators.maxLength(20),
      ]],
      'new_password_confirm': ['', [
        Validators.required,
        Validators.minLength(8),
        Validators.maxLength(20),
      ]]      
    });
  }

  onSubmit() {
    this.userService.updatePassword(this.changePasswordData).subscribe(data => {
      if (data.status === 200) {
        this.alertService.success('Password Changed Successfully', true);
        setTimeout(() => {
          this.router.navigate(['/dashboard']);
        }, 1000);
      }else {
        this.alertService.error(data.message);
      }
    },
    error => {
      this.alertService.error(error);
    });
  }

  passwordValueValidator(control) {
    if (control.value !== undefined && control.value.length >= 8) {
      if (control.value.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/)) {
        this.passwordSpecialMatch = false;
      } else {
        this.passwordSpecialMatch = true;
      }

    } else {
      this.passwordSpecialMatch = false;
    }
  }

  onKeyCheckpasswordConfirm(event: any) {
    if (event.target.value !== undefined) {
      if (this.changePasswordData.new_password === event.target.value) {
        this.matchPassword = false;
      } else {
        this.matchPassword = true;
      }
    } else {
      this.matchPassword = false;
    }
  }


  changePassword() {
    let $this = this;
    this.cognitoService.changePassword(this.changePasswordData.current_password, this.changePasswordData.new_password, this.changePasswordData.new_password_confirm)
      .then((reponse) => {
        $this.onSubmit();
      })
      .catch((error) => {
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/authorized-data/user/change-password/change-password.component.ts